export default "__VITE_ASSET__d79a5726__"